export function useRouterGuard(to) {
  const rawUser = localStorage.getItem('user');
  const currentUser = rawUser ? JSON.parse(rawUser) : {};

  const {
    roles = [],
    checkToHaveRole = [],
    ownerHasAccess = false
  } = to.meta || {};

  const userRoles = currentUser.roles?.map((r) => r.name) || [];
  const userRoleSet = new Set(userRoles);
  const isOwner = userRoleSet.has('owner');

  const hasRoleAccess = roles.length === 0 || roles.includes(currentUser.activeRole);

  const hasRequiredRole = checkToHaveRole.length === 0 || checkToHaveRole.some((r) => userRoleSet.has(r));

  const hasOwnerOverride = isOwner && ownerHasAccess;

  const hasAccessToRoute = isOwner ? hasOwnerOverride : (hasRoleAccess && hasRequiredRole);

  let pathToRedirect = currentUser.activeRole === 'contractor' ? '/realync-studios/dashboard' : '/home';

  if (isOwner) {
    pathToRedirect = '/properties';
  }

  return {
    hasAccessToRoute,
    pathToRedirect
  };
}
